<template>
    <div>
        <base-header-img img="page_02">
            中国领先的<br />
            以心脑专病数字医疗服务为核心的创新公司
        </base-header-img>
        <div class="about_content">
            <img class="icon_home_2" src="../assets/home-icon_3.png" />
            <div class="base_div">
                <div class="base_div_title">
                    <base-title title="公司介绍"></base-title>
                </div>

                <div class="base_text">
                    北京智煜健康科技有限公司，致力于成为中国领先的专病数字医疗服务为核心的创新公司，专注于心脑血管疾病垂直领域的数字化医疗服务体系，为专病患者提供院外数字化专病诊疗与管理服务，为临床医生专业能力提升与学术交流提供智慧医学引擎及创新工具，为行业机构提供数字化解决方案。
                    <br /><br />
                    智煜健康打造的心脑专病防控数字化解决方案平台——“医阵营”，核心业务包括患者数字伴侣和数字医疗与照护服务平台两大板块，构建全方位全周期的数字化医疗生态，延伸拓展医生价值，让患者得到自己信任的医生院外疾病管理和平台提供的快捷高效的服务。
                </div>
                <img
                    @click="$router.push('/product?key=1')"
                    class="about_img"
                    src="../assets/about-img-01.jpeg"
                />
                <img
                    @click="$router.push('/product?key=2')"
                    class="about_img"
                    src="../assets/about-img-02.jpg"
                />
            </div>
        </div>
        <div style="background-color: #f5f5f5; margin-top: 30px">
            <div class="base_div">
                <div class="base_div_title">
                    <base-title title="企业文化"></base-title>
                </div>
                <div class="about_qiye">
                    <div class="about_qiye_content">
                        <div
                            class="about_qiye_item"
                            v-for="(item, index) in list"
                            :key="index"
                        >
                            <div class="name">{{ item.name }}</div>
                            <div class="label">{{ item.label }}</div>
                        </div>
                    </div>
                    <img src="../assets/about-img-03.jpeg" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'about',
    data () {
        return {
            list: [
                { name: '使命', label: '以数字化解决方案提升中国专病防控水平，改善患者医疗结局。' },
                { name: '愿景', label: '致力于成为中国领先的以专病数字医疗服务为核心的创新公司。' },
                { name: '价值观', label: '努力创造，共同成就。' }
            ]
        }
    }
}
</script>
<style>
.about_img {
    width: 100%;
    height: auto;
    margin-top: 28px;
    cursor: pointer;
}
.about_content {
    position: relative;
}
.about_qiye {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 50px;
}
.about_qiye_content {
    margin-right: 40px;
    width: 500px;
}
.about_qiye img {
    width: 685px;
    height: auto;
}
.about_qiye_item {
    padding: 28px 0;
    font-weight: 400;
    border-bottom: 1px solid #e3e3e3;
}
.about_qiye_item:last-child {
    border-bottom: 0px;
}
.about_qiye_item .name {
    color: #1e1e1e;
    font-size: 30px;
}
.about_qiye_item .label {
    color: #3c3c3c;
    font-size: 20px;
    margin-top: 10px;
    font-weight: 300;
    line-height: 32px;
}
.icon_home_2 {
    height: 60px;
    width: auto;
    position: absolute;
    right: 0;
    top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/view/about.vue